// extracted by mini-css-extract-plugin
module.exports = {"container":"PopperWrapper_container__g49E_","arrow":"PopperWrapper_arrow__pe_hB"};